import { BlockedLocation, Contact, LanBooking, LanRegistration, LanSettingsPayload } from 'types/intra';

export const getMockRegistrations = (): LanRegistration[] => [
    {
        id: 'reg-001',
        firstname: 'Ada',
        lastname: 'Lovelace',
        nickname: 'FrostByte',
        email: 'ada@example.com',
        phone: '+358401234567',
        attendingThu: true,
        attendingFri: true,
        attendingSat: true,
        devicePc: true,
        food: true,
        dietL: true,
        dietG: true,
        history: 0,
        feedback: 'Laktoositon ruoka',
        createdAt: new Date().toISOString()
    },
    {
        id: 'reg-002',
        firstname: 'Linus',
        lastname: 'Torvalds',
        nickname: 'LanHero',
        email: 'linus@example.com',
        attendingFri: true,
        devicePc: true,
        history: 0,
        createdAt: new Date().toISOString()
    },
    {
        id: 'reg-003',
        firstname: 'Test',
        lastname: 'Player',
        nickname: 'ArchiveMe',
        email: 'archive@example.com',
        dietL: true,
        dietG: true,
        dietV: true,
        attendingSat: true,
        history: 1,
        createdAt: new Date().toISOString()
    }
];

export const getMockBookings = (): LanBooking[] => [
    {
        id: 'book-001',
        email: 'ada@example.com',
        code: 'A1',
        location: 'A1',
        invitationSent: true,
        done: 1,
        createdAt: new Date().toISOString()
    },
    {
        id: 'book-002',
        email: 'linus@example.com',
        code: 'B7',
        location: undefined,
        invitationSent: false,
        done: 0,
        createdAt: new Date().toISOString()
    }
];

export const getMockBlockedLocations = (): BlockedLocation[] => [
    {
        id: 'blocked-001',
        location: 'C1',
        createdAt: new Date().toISOString()
    }
];

export const getMockContacts = (): Contact[] => [
    {
        id: 'contact-001',
        role: 'coordinator',
        name: 'Pekka Peltomäki',
        phone: '+358 40 081 1178',
        email: 'pekkapeltomaki@msn.com',
        notes: 'Tapahtuman koordinaattori',
        displayOrder: 1,
        isPublic: true,
        createdAt: new Date().toISOString()
    },
    {
        id: 'contact-002',
        role: 'technical',
        name: 'Riku Kuusisto',
        phone: '+358 45 346 2128',
        email: 'rikse94@gmail.com',
        notes: 'Tekninen suunnittelu ja tuki',
        displayOrder: 2,
        isPublic: true,
        createdAt: new Date().toISOString()
    },
    {
        id: 'contact-003',
        role: 'payment',
        name: 'Riku Kuusisto',
        phone: '+358 45 346 2128',
        notes: 'MobilePay ja tilinumero: FI41 1807 2961 1628 14',
        displayOrder: 3,
        isPublic: true,
        createdAt: new Date().toISOString()
    }
];

export const getMockLanSettings = (): LanSettingsPayload => ({
    id: 'settings-001',
    total: 63,
    startDate: '2027-01-21',
    endDate: '2027-01-24',
    eventName: 'Tammilanit 2024',
    registrationEnabled: true,
    bookingEnabled: true,
    announcement: 'Mock-data käytössä, odottaa API-integraatiota.',
    
    // Branding fields
    appTitle: 'Tammilanit Intra',
    organizerName: 'Tammilanit-yhteisö',
    venueName: 'Porin helluntaikirkko',
    venueAddress: 'Itsenäisyydenkatu 9, 28100 Pori',
    logoPath: 'assets/Tammilanit 2026-logo.png',
    linksWebsite: 'https://tammilan.it',
    
    // Pricing fields
    pricingStandardSeatPrice: 20,
    pricingPremiumSeatPrice: 30,
    pricingStandardSeatDimensions: '100x75cm',
    pricingPremiumSeatDimensions: '120x80cm',
    pricingStandardSeatLabel: 'Peruspaikka',
    pricingPremiumSeatLabel: 'Siunattu paikka',
    
    // Payment fields
    paymentMobilePayNumber: '+358 45 346 2128',
    paymentBankAccount: 'FI41 1807 2961 1628 14',
    paymentBankAccountHolder: 'Riku Kuusisto',
    paymentInstructions: 'Paikkamaksu maksetaan lani-infossa ilmoitetuun Grilliporon tilinumeroon/Mobilepayhin.',
    
    // Contacts
    contacts: getMockContacts(),
    
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
});

